import { useState, useEffect, useRef } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewTodoWordPrintPopup from "@/pages/comp/plan/todo/popup/view_todo_word_print";
import WriteTodoWordPopup from "@/pages/comp/plan/todo/popup/write_todo_word";
import Style from "./css/style.module.css";
import TitleArea from "./area/title";
import StudySortArea from "./area/study_sort";
import WordTestResultArea from "./area/word_test_result";
import ManageBtnArea from "./area/manage_btn";

function ViewTodoWordResultOneArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    todo_pri_val_arr: [],
    ...props
  };

  let user = useSelector((state: any) => state.user);
  const [todo_info, set_todo_info] = useState<any>(null);
  const [word_pre_info, set_word_pre_info] = useState<any>(null);
  const [word_data_arr, set_word_data_arr] = useState<any>([]);
  const cg_word_arr_ref: any = useRef([]);
  const print_wrap_ref: any = useRef();
  const handlePrint = useReactToPrint({
    content: () => print_wrap_ref.current,
  });

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "view_todo_word_print",
    title: "오답 단어 인쇄",
    todo_pri_val_arr: [],
    is_only_fail_word: true,
    todo_data_arr: [],
    width: "900px",
    height: "85%",
  });

  useEffect(() => {
    get_todo_info_arr_by_ajax({
      todo_pri_val_arr: myProps.todo_pri_val_arr
    });
  }, []);

  const get_todo_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      "todo_pri_val_arr": myProps.todo_pri_val_arr,
      "is_reverse": true,
      ...inData
    };

    if (strFunc.is_empty(opt_obj.todo_pri_val_arr)) {
      return false;
    }

    let list_form_json = {
      "s_pri_arr": opt_obj.todo_pri_val_arr,
      "is_paging": "",
      "s_addon_par_content": "1",
      "s_addon_comp_user": "1",
      "s_addon_mcomp_title": "1",
      s_addon_cg_word_custom: "1",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let todo_info_item = response.data["data"]["info_arr"][0];
            set_todo_info(todo_info_item);

            let row_word_data_arr = [];
            if (todo_info_item && todo_info_item.mtextbook_info
              && todo_info_item.mtextbook_info.study_arr
            ) {
              let row_study_arr = todo_info_item.mtextbook_info.study_arr;
              for (let s_i = 0; s_i < row_study_arr.length; s_i++) {
                let row_study = row_study_arr[s_i];
                if (row_study.cg_word_arr) {
                  for (let i = 0; i < row_study.cg_word_arr.length; i++) {
                    let row_word = row_study.cg_word_arr[i];
                    row_word_data_arr.push(row_word);
                  }
                }
              }
            }
            if (todo_info_item && todo_info_item.word_inside_info
              && todo_info_item.word_inside_info.cg_word_arr
            ) {
              row_word_data_arr = todo_info_item.word_inside_info.cg_word_arr;
            }

            let row_select_word_data_arr = [];
            let row_start_idx = strFunc.uncomma_int(todo_info_item.a_success_amount_start);
            let row_word_cnt = strFunc.uncomma_int(todo_info_item.a_success_amount);
            for (let w_i = 0; w_i < row_word_data_arr.length; w_i++) {
              if (w_i >= row_start_idx && w_i < (row_start_idx + row_word_cnt)) {
                row_select_word_data_arr.push(row_word_data_arr[w_i]);
              }
            }

            if (todo_info_item && todo_info_item["a_sort_det"] == "cg_word_custom" && todo_info_item.cg_word_custom_arr) {
              row_word_data_arr = todo_info_item.cg_word_custom_arr;
              row_select_word_data_arr = todo_info_item.cg_word_custom_arr;
            }
            cg_word_arr_ref.current = row_select_word_data_arr;

            let row_word_data_arr2: any = [];
            for (let i = 0; i < row_select_word_data_arr.length; i++) {
              let row_data = row_select_word_data_arr[i];
              let word_data = {
                uid: i + 1,
                cont_part: row_data.a_cont_part,
                e_script: row_data.a_word,
                k_script: row_data.a_mean,
                mp3_file: "",
                cont_class: row_data.a_cont_part == "word" ? "VOCA" : "4-skills",
                mp3_file_url: "",
              };
              if (row_data.word_file_info && row_data.word_file_info.img_url) {
                word_data.mp3_file_url = row_data.word_file_info.img_url;
              }

              row_word_data_arr2.push(word_data);
            }
            set_word_data_arr(row_word_data_arr2);

            get_word_pre_info_by_ajax({
              todo_seq: todo_info_item.row_pri_val,
              stu_seq: todo_info_item.a_stu_mcomp_user_seq,
              word_data_arr: row_word_data_arr2
            });
          }
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const get_word_pre_info_by_ajax = (inData: any) => {
    let opt_obj = {
      todo_seq: "",
      stu_seq: "",
      word_data_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.todo_seq)) {
      return false;
    }
    if (strFunc.is_empty(opt_obj.stu_seq)) {
      return false;
    }
    let form_json: any = {
      s_mcomp_seq: "",
      stu_seq: opt_obj.stu_seq,
      coolen_study_par_id: "todo",
      coolen_study_par_seq: opt_obj.todo_seq,
      word_data_arr: opt_obj.word_data_arr,

      // pre_s_start_date: "",
      // pre_s_end_date: "",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/save_study/get_study_data', form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_word_pre_info(response.data["data"]);
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const onClickPrint = () => {
    if (print_wrap_ref.current) {
      print_wrap_ref.current.style.marginTop = "0px";
      print_wrap_ref.current.style.transform = "scale(1)";
      setTimeout(() => {

      }, 3000);
      setTimeout(() => { handlePrint(); }, 500);
    }
  };

  const open_view_todo_word_print_popup = () => {
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "view_todo_word_print",
      title: "오답 단어 인쇄",
      todo_pri_val_arr: myProps.todo_pri_val_arr,
      is_only_fail_word: true,
    });
  };

  const open_write_todo_word_popup = () => {

    //오답만 찾기
    let fail_word_det_arr: any = [];
    if (word_pre_info && word_pre_info.stu_word_det_info_arr) {
      for (let i = 0; i < word_pre_info.stu_word_det_info_arr.length; i++) {
        let row_det = word_pre_info.stu_word_det_info_arr[i];
        if (row_det.a_cont_sort_det == "white_paper_test") {
          if (row_det.a_correct_cnt) {

          } else {
            fail_word_det_arr.push(row_det);
          }
        }
      }
    }

    let fail_cg_word_arr: any = [];
    for (let i = 0; i < cg_word_arr_ref.current.length; i++) {
      let row_cg_word = cg_word_arr_ref.current[i];
      let is_exist_failt_word = false;
      for (let j = 0; j < fail_word_det_arr.length; j++) {
        let row_fail_word_det = fail_word_det_arr[j];
        if (row_fail_word_det.a_word == row_cg_word.a_word) {
          is_exist_failt_word = true;
          break;
        }
      }
      if (is_exist_failt_word == true) {
        fail_cg_word_arr.push(row_cg_word);
      }
    }

    let write_todo: any = {
      a_sort: "study",
      a_sort_det: "cg_word_custom",
      a_subject: "영어",
      a_title: "오답단어학습",
      a_success_amount: fail_cg_word_arr.length,
      a_success_amount_start: 0,
      cg_word_arr: fail_cg_word_arr,
      cg_word_custom_arr: fail_cg_word_arr,
    };

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "write_todo_word",
      title: "오답 단어 학습 생성",
      todo_data_arr: [write_todo],
    });
  };

  return (
    <div className={Style.popup_wrap}>
      <div ref={print_wrap_ref}>
        <TitleArea
          Style={Style}
          todo_info={todo_info}></TitleArea>
        {word_pre_info &&
          <StudySortArea
            Style={Style}
            todo_info={todo_info}
            word_pre_info={word_pre_info}
            word_data_arr={word_data_arr}
          ></StudySortArea>
        }
        <div>
          <WordTestResultArea
            Style={Style}
            todo_info={todo_info}
            word_pre_info={word_pre_info}
            word_data_arr={word_data_arr}
          ></WordTestResultArea>
        </div>
      </div>

      <div className='mt-2'>
        <ManageBtnArea
          Style={Style}
          onClickPrint={onClickPrint}
          open_view_todo_word_print_popup={open_view_todo_word_print_popup}
          open_write_todo_word_popup={open_write_todo_word_popup}
          closePopup={myProps.closePopup}
        ></ManageBtnArea>
      </div>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort == "view_todo_word_print" &&
            <ViewTodoWordPrintPopup
              todo_pri_val_arr={popupData.todo_pri_val_arr}
              is_only_fail_word={popupData.is_only_fail_word}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewTodoWordPrintPopup>
          }
          {popupData.sort == "write_todo_word" &&
            <WriteTodoWordPopup
              todo_data_arr={popupData.todo_data_arr}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTodoWordPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default ViewTodoWordResultOneArea;